export default __webpack_public_path__ + "static/media/share-preview-instagram.3b48aa62.png";